module.exports = __webpack_public_path__ + "img/14-full-md.fa0fb500.jpg";